import { Box, Checkbox, TextField, Typography, Stack, InputAdornment, Switch } from "@mui/material"
import { generateVoucher } from "../../../../core/global/GenerateRandom"
import { SnakeLoader } from "../../../../core/loader/SnakeLoader"
import { ValidateInt } from "../../../../core/validator/Validator"
import { env } from "../../../../core/Env"
import { rqx } from "../../../../core/request/API"
import { DeleteOutline } from "@mui/icons-material"

export const Payment = ({ setup_state }) => {
	const { trainingForm, paymentInfo } = setup_state
    const inputs = trainingForm.data
	const payment = paymentInfo.data 
	
	const handlePaymentChange = async (e, id, action) => {
		if (action === 'remove') { // REMOVE
			const u = paymentInfo.data.map((v) => {
				if (v.training_fee_type_id === id || v.temp_id === id) {
					return v.training_fee_type_id ? { ...v, active: 0 } : null
				}
				return v
			}).filter(v => v !== null)
			paymentInfo.set(u)
		} else if (e.target.name === 'requiredPRC' || e.target.name === 'showInShop') { // CHECKBOXES
			paymentInfo.set(payment.map((v) => v.training_fee_type_id === id || v.temp_id === id ? { ...v, [e.target.name]: e.target.checked } : v ))
		} else if (action === 'change_text') { // TEXTFIELDS
			paymentInfo.set(payment.map((v) => {
				if (v.training_fee_type_id === id || v.temp_id === id) {
					const updated = { ...v, [e.target.name]: e.target.value }
					return {
						...updated, price: updated.regularPrice - updated.discount
					}
				}
				return v
			}))
		} else if (e.target.name === 'voucherEnabled') { // VOUCHER FUNCTIONS
			getVoucher(e.target.checked, id)
		}
	}

	const getVoucher = async (checked, id) => {
		if (checked) {
			let voucher, res;
			if (inputs.method === 'update') {
				paymentInfo.set(payment.map((v) => v.training_fee_type_id === id || v.temp_id === id ? { ...v, loader: true } : v ))
				let attempts = 0;
				do {
					attempts++;
					voucher = generateVoucher();
					res = await rqx.get(`<<tool>>/${env()}/setupTraining/check_voucher`, {training_id: inputs.id, voucher})
					if (attempts > 10) {
						console.error("Failed to generate unique voucher after 10 tries");
						paymentInfo.set(payment.map((v) => v.training_fee_type_id === id || v.temp_id === id ? { ...v, loader: false } : v ))
						return;
					}
				} while (res.status === "Existing");	
			} else {
				voucher = generateVoucher();
			}
			paymentInfo.set(payment.map((v) => v.training_fee_type_id === id || v.temp_id === id ? { ...v, voucherCode: voucher, voucherEnabled: true, loader: false } : v ))
		} else {
			paymentInfo.set(payment.map((v) => v.training_fee_type_id === id || v.temp_id === id ? { ...v, voucherCode: "", voucherEnabled: false, loader: false } : v )) // when unchecked, clear the voucher
		}
	}

	const hasDuplicate = (name) => {
		const normalizedName = name.trim().toLowerCase()
		const count = payment.filter(v => v.name.trim().toLowerCase() === normalizedName).length
		return count > 1
	}

	return (
		<Stack gap='0.5rem'>
			<Stack direction='row' gap='0.5rem' alignItems='center'>
				{ ['Fee Type','Regular Price','Discount in Amount','Price','Voucher Code','Require PRC ID No.','Show in Shop'].map((v,k) => (
					<Typography key={k} fontSize={14} align='center' sx={{ color: '#292C2F', 
						...(
								v === 'Fee Type' ? { width: "10rem" } :
								v === 'Voucher Code' ? { width: "9rem" } : 
								v === 'Require PRC ID No.' ? { width: "5rem", ml: '1rem' } :
								v === 'Show in Shop' ? { width: "5rem", mr: '1rem' } : { flex: 1 }
							) 
					}}>{v}</Typography>
				)) }
				<Box width='1.5rem'/>
			</Stack>
			<Stack gap='1rem'>
				{ payment.filter(v => v.active).map((v,k) => (
					<Stack key={k} direction='row' gap='0.5rem' alignItems='center'>
						<TextField size="small" name='name' value={v.name} error={(v.name.trim() === "" || hasDuplicate(v.name)) && inputs.error} onChange={(e) => handlePaymentChange(e, v.training_fee_type_id || v.temp_id, 'change_text')} sx={{ width: '10rem', "& .MuiInputBase-root.Mui-disabled": { backgroundColor: "#F7F8F8" } }}/>
						<TextField size="small" name='regularPrice' value={v.regularPrice} error={!v.regularPrice && inputs.error} onChange={(e) => handlePaymentChange(e, v.training_fee_type_id || v.temp_id, 'change_text')} sx={{ flex: 1, "& .MuiInputBase-root.Mui-disabled": { backgroundColor: "#F7F8F8" } }} onKeyDown={ValidateInt}/>
						<TextField size="small" disabled={!v.regularPrice} name='discount' value={v.discount} onChange={(e) => handlePaymentChange(e, v.training_fee_type_id || v.temp_id, 'change_text')} sx={{ flex: 1, "& .MuiInputBase-root.Mui-disabled": { backgroundColor: "#F7F8F8" } }} onKeyDown={ValidateInt}/>
						<TextField size="small" value={v.price} error={v.price < 0 && inputs.error} InputProps={{ readOnly: true }} sx={{ flex: 1, bgcolor: "#F7F8F8" }}/>
						<TextField size="small" disabled 
							value={v.voucherCode}
							sx={{ width: "9rem", "& .MuiInputBase-root.Mui-disabled": { backgroundColor: "#F7F8F8" } }} 
							InputProps={{ 
								...(v.loader && 
									{ startAdornment: (<InputAdornment position="start"> <SnakeLoader size="6px" bg="#009F4D" distance="0.25rem" /></InputAdornment>) }), 
								endAdornment: (<InputAdornment position="end"> 
									<Switch edge="end" 
									disabled={!(v.regularPrice && v.discount && !v.loader)} 
									size="small" 
									name='voucherEnabled' 
									checked={v.voucherEnabled} 
									onChange={(e) => handlePaymentChange(e, v.training_fee_type_id || v.temp_id, null)}/> 
								</InputAdornment>)}}/>
						<Checkbox name='requiredPRC' checked={v.requiredPRC} onChange={(e) => handlePaymentChange(e, v.training_fee_type_id || v.temp_id, null)} sx={{ width: '5rem', ml: '1rem', ':hover': { bgcolor: '#fff' } }}/>
						<Checkbox name='showInShop' checked={v.showInShop} onChange={(e) => handlePaymentChange(e, v.training_fee_type_id || v.temp_id, null)} sx={{ width: '5rem', mr: '1rem', ':hover': { bgcolor: '#fff' } }}/>
						{ k !== 0 ?
							<DeleteOutline onClick={() => handlePaymentChange(null, v.training_fee_type_id || v.temp_id, 'remove')} sx={{ width: 'auto', cursor: 'pointer', transition: '0.25s', ':hover': { color: '#E34935' } }} />
						:
							<Box width='24px'/>
						}
					</Stack>
				)) }
			</Stack>
		</Stack>
	)
}
